import gql from 'graphql-tag';

export const getRegistrationTimes = gql`
  query getRegistrationTimes(
    $courseId: String!
    $period: String!
    $prog: String!
    $plan: String!
    $career: String!
    $campus: String!
  ) {
    coursesSchedules {
      getSchedules(
        courseId: $courseId
        period: $period
        prog: $prog
        plan: $plan
        career: $career
        campus: $campus
      ) {
        courseId
        section
        schedules {
          day
          start
          end
        }
        teachers
        typeCourse
      }
    }
  }
`;
